import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-company-share-settings', standalone: true, imports: [CommonModule, FormsModule],
  templateUrl: './company-share-settings.component.html',
})
export class CompanyShareSettingsComponent implements OnInit {
  data: any;
  draft: any = { enabled: true, period: '', target_id: '', percent: '', basis: '', loss: '' };
  busy = false;
  error = '';
  success = '';
  constructor(private http: HttpService) {}
  ngOnInit() { void this.load(); }
  async load() {
    this.error = '';
    try {
      const response: any = await this.http.post('/admin/company-share/get');
      if (!response?.status) throw Error(response?.message || 'Unable to load share split settings.');
      this.data = response;
    } catch (error: any) { this.error = error?.message || 'Unable to load share split settings.'; }
  }
  async save() {
    if (this.busy || !this.data?.can_edit) return;
    this.error = ''; this.success = ''; this.busy = true;
    try {
      const response: any = await this.http.post('/admin/company-share/save', { ...this.draft, revision: this.data.revision });
      if (!response?.status) throw Error(response?.message || 'Unable to save share split. Reload and try again.');
      this.success = response.message;
      this.draft = { enabled: true, period: '', target_id: '', percent: '', basis: '', loss: '' };
      await this.load();
    } catch (error: any) { this.error = error?.message || 'Unable to save share split.'; }
    finally { this.busy = false; }
  }
}
